export const AUTH_BOOTSTRAP = 'AUTH_BOOTSTRAP'
export const AUTH_LOGGED_IN = 'AUTH_LOGGED_IN'
export const AUTH_LOGGED_OUT = 'AUTH_LOGGED_OUT'
export const AUTH_SET_IS_LOGGED_IN = 'AUTH_SET_IS_LOGGED_IN'



// WEBPACK FOOTER //
// ./src/redux/auth/actionTypes.js